import React from 'react';
import {
  Box,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

export function relativeTime(value) {
  const date = new Date(value);
  const elapsedMinutes = Math.max(0, Math.floor((Date.now() - date.getTime()) / 60000));
  if (elapsedMinutes < 1) return 'Just now';
  if (elapsedMinutes < 60) return `${elapsedMinutes} min ago`;
  const elapsedHours = Math.floor(elapsedMinutes / 60);
  if (elapsedHours < 24) return `${elapsedHours} h ago`;
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) return 'Yesterday';
  return date.toLocaleDateString();
}

const RecentFilesTable = ({ files = [], showAllFiles = false, emptyMessage = 'No files yet.' }) => {
  if (files.length === 0) {
    return <Typography color="text.secondary" sx={{ py: 1 }}>{emptyMessage}</Typography>;
  }

  return (
    <TableContainer sx={{ width: '100%' }}>
      <Table size="small" aria-label="Recent files">
        <TableHead>
          <TableRow sx={{ bgcolor: '#f7f9fa' }}>
            <TableCell>File</TableCell>
            <TableCell>Type</TableCell>
            <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Rows</TableCell>
            <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>When</TableCell>
            <TableCell align="right">Download</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {files.map(entry => (
            <TableRow key={entry.id} hover>
              <TableCell sx={{ maxWidth: 240, overflowWrap: 'anywhere' }}>
                {entry.files.map(file => file.name).join(' + ')}
              </TableCell>
              <TableCell sx={{ textTransform: 'capitalize' }}>{entry.type}</TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                {Number(entry.rows || 0).toLocaleString()}
              </TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                {relativeTime(entry.createdAt)}
              </TableCell>
              <TableCell align="right">
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, flexWrap: 'wrap' }}>
                  {entry.zipUrl && (
                    <Link href={entry.zipUrl} underline="always" sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                      Download .zip
                    </Link>
                  )}
                  {showAllFiles
                    ? entry.files.map(file => (
                      <Link
                        key={file.downloadUrl}
                        href={file.downloadUrl}
                        underline="always"
                        sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}
                      >
                        {file.kind === 'master' ? 'Master' : file.kind === 'storefront' ? 'Storefront' : 'Download'}
                      </Link>
                    ))
                    : !entry.zipUrl && entry.files[0] && (
                      <Link href={entry.files[0].downloadUrl} underline="always" sx={{ fontWeight: 700 }}>
                        Download
                      </Link>
                    )}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecentFilesTable;
